import React from "react";
import logo from "../../Assets/img/login/dataradar_new_logo_white.png";

type SupportContainerProps = {
    imageSrc?: string | React.ReactNode;
    details: React.ReactNode;
};

const SupportContainer = ({ imageSrc, details }: SupportContainerProps) => {
    return (
        <div className="rounded-lg p-8 flex flex-col items-center w-full h-full drop-shadow-md">
            <div className="w-full h-32 flex items-center justify-center">
                {typeof imageSrc === "string" ? (
                    <img src={imageSrc} alt="support" className="max-w-full max-h-full" />
                ) : (
                    imageSrc
                )}
            </div>
            <div className="w-full mt-4 text-left">{details}</div>
        </div>
    );
};

export default function Support() {
    const MailSVG = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-64 w-64 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M3 8.5v7A2.5 2.5 0 005.5 18h13A2.5 2.5 0 0021 15.5v-7A2.5 2.5 0 0018.5 6h-13A2.5 2.5 0 003 8.5z"
            />
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M21 8.5l-9 6-9-6"
            />
        </svg>
    );

    return (
        <div className="flex flex-col items-center justify-start h-screen bg-login-bg bg-no-repeat bg-cover w-full">
            <img src={logo} alt="DataRadar Logo" className="w-1/5 py-4" srcSet="" />

            <div className="sign-up text-center px-12"></div>
            <div className="w-full text-center text-white text-4xl font-bold pb-3">Support</div>
            <div className="mx-auto w-max flex justify-around flex-wrap items-center gap-8 px-6">
                <SupportContainer
                    imageSrc={MailSVG}
                    details={
                        <>
                            <p className="text-white w-full text-left text-2xl mt-4">
                                {'  '}If you have any other questions don't hesitate to contact us on {'  '}
                                <a className="font-bold underline" href="mailto:support@dataradar.io" target="_blank" rel="noreferrer">
                                    support@dataradar.io
                                </a>
                            </p>
                            <p className="text-white w-full text-left text-2xl mt-4">
                                To know more about our company, please visit{' '}
                                <a className="font-bold underline" href="https://dataradar.io/" target="_blank" rel="noreferrer">
                                    https://www.dataradar.io
                                </a>
                            </p>
                        </>
                    }
                />
            </div>

        </div>
    );
}
